export default "__VITE_ASSET__BNNNxzUl__"